<template>
  <div v-if="type !== 'viewOnly'" class="is-flex width-100 is-justify-content-space-between">
    <!-- type: {{ type }} -->
    <b-button
      v-if="showEditor"
      @click="$emit('incrementWeek', true)"
      type="is-text"
      class="has-text-info mr-2"
      icon-right="plus-thick"
    >
      <strong>Add Week</strong>
    </b-button>

    <div>
      <b-button v-if="type==='saveNew'" @click="saveTemplate()" class="is-success" icon-right="upload" rounded>
        <strong>Save Template</strong>
      </b-button>
      <b-button v-if="type==='editExisting'" @click="updateExistingPlan()" class="is-success" icon-right="upload" rounded>
        <strong>Save {{ selectedTemplate.name }}</strong>
      </b-button>
      <b-button v-if="type==='updateCustomer'" @click="updatePatientPlan()" class="is-success" icon-right="upload" :loading="isLoading" rounded>
        <strong>Save Changes</strong>
      </b-button>
      <b-button v-if="type==='newCustomer'" @click="addMember()" class="is-success" icon-right="upload" rounded>
        <strong>Add Patient</strong>
      </b-button>
      <!-- only for us to see -->
      <b-button v-if="user.email==='zestytesty@test.com'" @click="saveAsDefault()" rounded>
        <strong>Save as Default</strong>
      </b-button>
    </div>

  </div>
</template>

<script>
import { db, references } from "@/main";
import { mapState } from "vuex";

import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: "builderMenuBar",
  props: {
    showEditor: Boolean
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      type: state => state.builderMenuType,
      selectedTemplate: state => state.selectedTemplate,
      isLoading: state => state.isLoading,
      logged_in_uid: state => state.auth.logged_in_uid,
      practice: state => state.auth.practice,
      introVideos: state => state.introVideos, // NEW
      outroVideos: state => state.outroVideos, // NEW
    }),
  },
  methods: {
    randomFromArray(arr) { 
      return arr[(Math.random() * arr.length) | 0];
    },
    saveAsDefault() { // for making dfault templates. only visible to zestytesty@test.com
      this.$buefy.dialog.prompt({
        title: "Save Default",
        message: "Plan Name",
        inputAttrs: {
          placeholder: "e.g. ACL Reconstruction"
        },
        trapFocus: true,
        onConfirm: async (name) => {
          await save(name);
          this.$root.$emit("closeSaveConfirm");
        }
      });
      let save = async (name) => {
        db.collection("protocolTemplates")
        .add({ name, weeks: this.selectedTemplate.weeks })
        .then(() => {
          this.$buefy.toast.open({
            message: "Saved template",
            position: "is-top"
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: "Failed to save template",
            type: "is-danger",
            position: "is-top"
          });
        });
      }
    },
    addMember() {
      // console.log(this.selectedTemplate)
      const patientCode = Math.random().toString(36).substr(2, 6).toUpperCase(); // get 6 character random key
      const object = { // build the user object
        firstName: this.$root.firstName,
        lastName: this.$root.lastName,
        email: this.$root.email,
        therapistEmail: this.user.email,
        recoveryType: this.selectedTemplate.name,
        createdAt: new Date(),
        patientCode,
        practice_id: this.practice.practice_id,
      };

      const userRef = db.collection("patientProgress").doc(patientCode);
      const therapistRef = db.collection(references.practice).doc(this.user.practice.id).collection('patients').doc(patientCode)

      userRef
        .get() // check if exists
        .then(docSnapshot => {
          if (docSnapshot.exists) {
            // console.log("path exists already!");
            this.addMember(); // recursion so we re create the patientCode and try again
          } else {
            userRef.set(object);
            therapistRef.set(object);
            // this.$store.dispatch('bindPatientsList') // TODO: why is vuexfire not changing in real time? Manually dispatch so we update patients List
            this.sendNewPlan(patientCode, "name goes here"); // TODO: allow user to write the plan's name
            db.collection("mailingList")
              .add({ to: this.$root.email, message: {
                subject: `Welcome to Aceso Recovery`,
                html: `<head> <meta name="color-scheme" content="light dark"> </head>
                        <div style="background-color: whitesmoke; width: 100%; height: auto; padding-bottom: 25px">
                        <h1 style="color: #222222; text-align: center; font-family: Tahoma, Verdana, sans-serif; padding-top: 25px"> Welcome! </h1>
                        <h1 style="color: #222222; text-align: center; font-family: Tahoma, Verdana, sans-serif; padding-top: 5px"> ${this.$root.firstName} ${this.$root.lastName} </h1>
                        <h3 style="font-family: Tahoma, Verdana, sans-serif; color: #222222; text-align: center;"> To get started, click the link below and sign in with your 6 digit patient code</h3> 
                        <h1 style="color: #222222; text-align: center; font-family: Tahoma, Verdana, sans-serif; padding-top: 5px"> ${patientCode} </h1>  
                        <div style="display: flex; justify-content: center; margin: auto; width: auto; height: auto; align-content: center "> <a style="border-radius: 25px; padding-top: 12px; padding-bottom: 12px; padding-left: 18px; padding-right: 18px; background-color: #18a0fb; font-family: Tahoma, Verdana, sans-serif; color: white !important; text-decoration: none; " href='https://www.acesorecovery.com/patientlogin'> Start Workout! </a> </div>
                        </div>`
                },
              })
              .catch(err => {
                console.log(err)
              });
          }
        });
    },
    // creates a new plan
    async sendNewPlan(patientCode, name) {
      // all the practice's data, independant of plan
      const google_reviews_link = this.practice.google_reviews_link || 'https://www.facebook.com/pg/AcesoRecovery/reviews/';
      const practice_url = this.practice.practice_url || 'https://www.acesorecovery.com';
      const logo_url = this.practice.practice_logo || 'https://storage.googleapis.com/aceso-webflow-project.appspot.com/practices/DEFAULTS/Logo.png';

      let video_intro, video_outro;
      if (this.practice.video_intro) {
        video_intro = {
          type: 'intro',
          file: this.practice.video_intro,
          screenshots: [ // josh is using screenshots[2], so we make it a 3 item array
            {}, {}, { link: logo_url } // just using practice logo as screenshot
          ]
        }
      } else {
        video_intro = this.randomFromArray(this.introVideos);
      }
      if (this.practice.video_outro) {
        video_outro = {
          type: 'outro',
          file: this.practice.video_outro,
          screenshots: [ // josh is using screenshots[2], so we make it a 3 item array
            {}, {}, { link: logo_url } // just using practice logo as screenshot
          ]
        }
      } else {
        video_outro = this.randomFromArray(this.outroVideos);
      }

      video_intro.name = 'Intro';
      video_outro.name = 'Outro';

      // add an intro and outro to each playlist
      let weeks = JSON.parse(JSON.stringify(this.selectedTemplate.weeks)); // avoid changing the original array
      weeks.forEach(week => {
        week.playlists.forEach(playlist => {
          playlist.videos.unshift(video_intro);
          playlist.videos.push(video_outro);
        })
      })

      // get PT title and PFP
      const title = this.user.title || 'PT';
      const profile_pic = this.user.profile_pic || 'https://storage.googleapis.com/aceso-webflow-project.appspot.com/practices/DEFAULTS/profile_pic.JPG';

      // build the plan, combining everything
      const object = { 
        weeks,
        sentAt: new Date(), 
        recoveryType: name,
        updatedBy: {
          practice_id: this.practice.practice_id,
          uid: await firebase.auth().currentUser.uid,
          name: this.user.name,
          practice_name: this.practice.practice_name,
          google_reviews_link,
          practice_url,
          logo_url,
          title,
          profile_pic,
          // video_intro,
          // video_outro
        } // NEW TODO
      };
      await db
        .collection("patientProgress") 
        .doc(patientCode)
        .collection("progress")
        .doc("plan")
        .set(object)
        .then(() => {
          this.$buefy.toast.open({
            message: "Plan sent!",
            position: "is-top"
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: "Failed to send plan",
            type: "is-danger",
            position: "is-top"
          });
        });
      this.$root.$emit("closeAddPatient", "add");
    },
    // updates an existing plan
    async updatePatientPlan() {
      // practice data, independant of plan
      const google_reviews_link = this.practice.google_reviews_link || 'https://www.facebook.com/pg/AcesoRecovery/reviews/';
      const practice_url = this.practice.practice_url || 'https://www.acesorecovery.com';
      const logo_url = this.practice.practice_logo || 'https://storage.googleapis.com/aceso-webflow-project.appspot.com/practices/DEFAULTS/Logo.png';

      // set intro and outro according to how josh uses it, whether it be a custom or default video
      let video_intro, video_outro;
      if (this.practice.video_intro) { // if there is a practice intro, construct it according to how josh uses it
        video_intro = {
          type: 'intro',
          file: this.practice.video_intro,
          screenshots: [ // josh is using screenshots[2], so we make it a 3 item array
            {}, {}, { link: logo_url } // just using practice logo as screenshot
          ]
        }
      } else {
        video_intro = this.randomFromArray(this.introVideos);
      }
      if (this.practice.video_outro) { // if there is a practice outro, construct it according to how josh uses it
        video_outro = {
          type: 'outro',
          file: this.practice.video_outro,
          screenshots: [ // josh is using screenshots[2], so we make it a 3 item array
            {}, {}, { link: logo_url } // just using practice logo as screenshot
          ]
        }
      } else {
        video_outro = this.randomFromArray(this.outroVideos);
      }

      video_intro.name = 'Intro';
      video_outro.name = 'Outro';
      
      // add an intro and outro to each playlist
      let weeks = JSON.parse(JSON.stringify(this.selectedTemplate.weeks)); // avoid changing the original array
      
      weeks.forEach((week, weekIdx) => { // manually remove and replace 
        week.playlists.forEach((playlist, playlistIdx) => {
          /* manually replace intro and outro
             ensures new playlists have intros and outros
             new intros and outros for every playlist every time the PT saves changes
          */
          playlist.videos[0] = video_intro; // replace with potentially new intro
          weeks[weekIdx].playlists[playlistIdx].videos = playlist.videos.filter(e => { return e.type !== "outro" }); // remove old outro
          playlist.videos.push(video_outro); // push potentially new outro
        })
      })
      // console.log(weeks);

      // get PT title and PFP
      const title = this.user.title || 'PT';
      const profile_pic = this.user.profile_pic || 'https://storage.googleapis.com/aceso-webflow-project.appspot.com/practices/DEFAULTS/profile_pic.JPG';

      await db
        .collection("patientProgress")
        .doc(this.$root.selectedPatientID)
        .collection("progress")
        .doc("plan")
        .update({
          weeks,
          updatedAt: new Date(),
          updatedBy: {
            uid: await firebase.auth().currentUser.uid,
            name: this.user.name,
            google_reviews_link,
            practice_url,
            logo_url,
            title,
            profile_pic,
            practice_name: this.practice.practice_name,
          } // NEW TODO
        })
        .then(() => {
          this.$buefy.toast.open({
            message: "Plan updated!",
            position: "is-top"
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: "Failed to update plan",
            type: "is-danger",
            position: "is-top"
          });
        });
      this.$root.$emit("closeShowPatientData", "update");
    },
    saveTemplate() {
      this.$buefy.dialog.prompt({
        title: "Save",
        message: `Plan Name`,
        inputAttrs: {
          placeholder: "e.g. ACL Reconstruction"
        },
        trapFocus: true,
        onConfirm: async (name) => {
          await save(name);
          // this.$store.dispatch("bindCustomTemplates", this.$store.state.user.email);
          this.$root.$emit("closeSaveConfirm");
        }
      });

      let save = async (name) => {
        // db.collection("TherapistAccounts").doc(this.user.email).collection("customTemplates")
        db.collection(references.practice).doc(this.user.practice.id).collection('customTemplates')
        .add({ name, weeks: this.selectedTemplate.weeks })
        .then(() => {
          this.$buefy.toast.open({
            message: "Saved template",
            position: "is-top"
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: "Failed to save template",
            type: "is-danger",
            position: "is-top"
          });
        });
      }
    },
    async updateExistingPlan() {
      // await db.collection('TherapistAccounts').doc(this.user.email).collection('customTemplates').doc(this.selectedTemplate.id)
      await db.collection(references.practice).doc(this.user.practice.id).collection('customTemplates').doc(this.selectedTemplate.id)
        .update({
          name: this.selectedTemplate.name,
          weeks: this.selectedTemplate.weeks
        })
        .then(() => {
          this.$buefy.toast.open({
            message: "Saved Changes",
            position: "is-top"
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: "Failed to save changes",
            type: "is-danger",
            position: "is-top"
          });
        });
      this.$root.$emit("closeSaveConfirm");
    }
  }
};
</script>